import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M18 10.139c4.418 0 8 3.608 8 8.06 0 3.56-2.29 6.58-5.466 7.646-.406.08-.55-.172-.55-.386 0-.266.01-1.134.01-2.212 0-.752-.256-1.242-.544-1.492 1.782-.2 3.654-.882 3.654-3.977 0-.88-.31-1.6-.824-2.164.083-.203.358-1.023-.078-2.133 0 0-.67-.216-2.198.826a7.6 7.6 0 0 0-2.004-.27 7.6 7.6 0 0 0-2.002.27c-1.53-1.042-2.201-.826-2.201-.826-.435 1.11-.16 1.93-.078 2.133a3.13 3.13 0 0 0-.824 2.164c0 3.087 1.868 3.78 3.645 3.983-.229.201-.436.556-.508 1.078-.456.206-1.614.562-2.328-.67 0 0-.423-.774-1.226-.83 0 0-.78-.011-.055.489 0 0 .524.248.888 1.179 0 0 .47 1.438 2.695.951.004.674.012 1.309.012 1.5 0 .214-.148.463-.547.388A8.055 8.055 0 0 1 10 18.198c0-4.451 3.582-8.06 8-8.06",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-github"}) } }